/**
 * Debug flight recorder for the referee PWA (@flm9/telemetry-client).
 * Records only while the opened training is live (the server decides) —
 * nothing on the sign-in / session-picker screens (no training selected).
 */
import { initTelemetryClient, track } from '@flm9/telemetry-client';

let currentSessionId: string | null = null;

export function startTelemetry(): void {
  initTelemetryClient({ surface: 'referee', getSessionId: () => currentSessionId });
}

/** Called by App whenever the open training changes (null = none). */
export function setTelemetrySession(sessionId: string | null): void {
  currentSessionId = sessionId;
}

/**
 * Run an API mutation as an explicit intent ("what was supposed to happen"),
 * recording its outcome. The API calls inside join the intent's trace.
 */
export function tracked<T>(name: string, intent: unknown, run: () => Promise<T>): Promise<T> {
  const handle = track(name, intent);
  return run().then(
    (result) => {
      handle.ok(result ?? null);
      return result;
    },
    (err: unknown) => {
      handle.fail(err);
      throw err;
    },
  );
}
